import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    cta: 'All good!',
    explanation:
      'You do not have to add a mandate: simply provide your banking details to your creditor. There is nothing more to be done in Shine!',
    link: 'Learn more',
    title: 'Your creditor takes care of everything!',
  },
  fr: {
    cta: 'C’est tout bon\xA0!',
    explanation:
      'Vous n’avez pas besoin d’ajouter de mandat, il vous suffit de transmettre vos coordonnées bancaires à votre créancier. Il n’y a rien de plus à faire dans Shine\xA0!',
    link: 'En savoir plus',
    title: 'Votre créancier s’occupe de tout\xA0!',
  },
});

export default locales;
